(function() {

    'use strict';

    angular.module('app').
    controller('FtpDirectBookingHistoryController', FtpDirectBookingHistoryController);

    FtpDirectBookingHistoryController.$inject = ['$scope', '$uibModal', 'FTPHistoricalInputsTable'];

    function FtpDirectBookingHistoryController($scope, $uibModal, FTPHistoricalInputsTable) {

        const vm = this;
        vm.viewFtpCredentials = viewFtpCredentials;
        init();

        function init() {
            vm.fTPHistoricalInputsTable = (new FTPHistoricalInputsTable).tableData;
        }
        
        function viewFtpCredentials() {
            
        }
    }
})();


// WEBPACK FOOTER //
// ./js/controllers/manifests/FtpDirectBookingHistoryController.js